import { render, staticRenderFns } from "./CommissionModel.vue?vue&type=template&id=938d7906&scoped=true&"
import script from "./CommissionModel.vue?vue&type=script&lang=js&"
export * from "./CommissionModel.vue?vue&type=script&lang=js&"
import style0 from "./CommissionModel.vue?vue&type=style&index=0&id=938d7906&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938d7906",
  null
  
)

export default component.exports